import React from "react";
import { StatsCard } from "./StatsCard";
import { Spinner } from "../common/Spinner";
import { formatNumber } from "../../utils/format.utils";
import {
  BarChart3,
  CheckCircle2,
  Clock,
  XCircle,
  Zap,
  Users,
} from "lucide-react";

interface JobStats {
  total_jobs: number;
  completed: number;
  pending: number;
  failed: number;
  processing: number;
  by_type: Record<string, number>;
}

export interface StatsGridProps {
  stats: JobStats | null;
  loading?: boolean;
}

export const StatsGrid: React.FC<StatsGridProps> = ({
  stats,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="text-center py-8 text-slate-400">
        No statistics available
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      <StatsCard
        title="Total Jobs"
        value={formatNumber(stats.total_jobs)}
        icon={<BarChart3 className="w-5 h-5" />}
        color="primary"
      />

      <StatsCard
        title="Completed"
        value={formatNumber(stats.completed)}
        icon={<CheckCircle2 className="w-5 h-5" />}
        color="success"
      />

      <StatsCard
        title="Pending"
        value={formatNumber(stats.pending)}
        icon={<Clock className="w-5 h-5" />}
        color="warning"
      />

      <StatsCard
        title="Failed"
        value={formatNumber(stats.failed)}
        icon={<XCircle className="w-5 h-5" />}
        color="danger"
      />

      <StatsCard
        title="Processing"
        value={formatNumber(stats.processing)}
        icon={<Zap className="w-5 h-5" />}
        color="accent"
      />

      <StatsCard
        title="People Counting"
        value={formatNumber(stats.by_type?.people_counting || 0)}
        icon={<Users className="w-5 h-5" />}
        color="info"
      />
    </div>
  );
};
